import React, { Component } from 'react';
import { connect } from 'react-redux';
import SizeItem from './SizeItem';

class ProductAmountSelections extends Component {
  constructor(props) {
    super(props);
    this.state = {
      translatePosition: 0,
      isMobile: false,
    };
    this.goLeft = this.goLeft.bind(this);
    this.goRight = this.goRight.bind(this);
    this.isMobile = this.isMobile.bind(this);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.isMobile);
  }

  UNSAFE_componentWillMount() {
    this.isMobile();
    window.addEventListener('resize', this.isMobile);
  }

  isMobile() {
    const width = window.innerWidth ||
    document.documentElement.clientWidth ||
    document.body.clientWidth;
    if (width < 768) {
      this.setState({ isMobile: true });
    } else {
      this.setState({ isMobile: false });
    }
  }

  goLeft() {
    this.setState(prevState => ({ translatePosition: prevState.translatePosition - 110 }));
  }

  goRight() {
    this.setState(prevState => ({ translatePosition: prevState.translatePosition + 110 }));
  }

  render() {
    const mobileStyle = {
        container: {
            width: '100%',
        },
    };
    const desktopStyle = {
        container: {
          width: `${this.props.sizes.length * 110}px`,
          transform: `translateX(${this.state.translatePosition}px)`,
        },
    };

    return (
      <div className="productContainer">
        <div className="productImageContainer">
          <img src={this.props.image} alt="product chosen" />
          <p>{this.props.name}</p>
        </div>
        <div className="sizesContainer">
          {this.props.sizes.length > 3 ?
            <div className="leftNav" onClick={() => this.goLeft()} role="button" tabIndex="0" style={{ outline: 'none' }}>
              <span className="arrow" />
            </div>
            :
            null
          }
          {this.state.translatePosition < 0 ?
            <div className="rightNav" onClick={() => this.goRight()} role="button" tabIndex="0" style={{ outline: 'none' }}>
              <span className="arrow" />
            </div>
            :
            null
          }
          <div className="scrollHolder">
            <div
              className="scroller"
              style={this.state.isMobile ? mobileStyle.container : desktopStyle.container}
            >
              {this.props.sizes.map(size => (<SizeItem
                productID={this.props.productID}
                choiceID={this.props.choicesID}
                key={size.id}
                sizeId={size.id}
                name={size.name}
                amount={size.amount || ''}
                inStock={size.in_stock}
                getTotal={this.getTotal}
                subgroupID={this.props.subgroupID}
              />))}
            </div>
          </div>

          <div className="totalSelectionContainer">
            <div>
              Total :
              <span className="total">
                {this.props.sizeSelection.filter(ss => ss.productID === this.props.productID
                                                      && ss.subgroupID === this.props.subgroupID)
                                          .reduce((sum, size) => {
                                            return sum + parseInt(size.amount, 10);
                                          }, 0)}
              </span>
            </div>
          </div>
        </div>

      </div>
    );
  }
}
const mapState = state => (
  {
    sizeSelection: state.sizeSelection,
  }
);

export default connect(mapState, null)(ProductAmountSelections);
